<div>
    @if (isHelpBoxVisible) {
        <ms-help-box class="help-teaser-bet" [boxType]="helpBoxType.TeaserBet" (closeButtonClick)="onHelpBoxClose()"> </ms-help-box>
    }

    <bs-teaser-bet-point-selector
        [steps]="teaseSteps"
        [sliderValue]="teaseValue"
        [stepValue]="teaserStepValue"
        [stepDivider]="teaserStepDivider"
        [isLinear]="isLinear"></bs-teaser-bet-point-selector>
    <span class="teaser-bet-divider"></span>
    <bs-teaser-bet-header [isLinear]="isLinear"></bs-teaser-bet-header>
    <div class="bs-teaser-list">
        <bs-teaser-bet [teaserBetState]="teaserInfo" [pickList]="pickList()" [oddsDisplayFormat]="oddsDisplayFormat"></bs-teaser-bet>
    </div>

    @if (isLinear) {
        <bs-teaser-bet-linear-summary [oddsDisplayFormat]="oddsDisplayFormat" [teaserText]="teaserText$ | async" />

        <div class="teaser-bet-linear__rewards">
            <bs-digital-token-summary-container
                *msShowInEpcot="{ showInEpcot: false, module: module }"
                [tokenContext]="{ betslipType }"></bs-digital-token-summary-container>
            <bs-reward-tokens-selector-container [tokenContext]="{ betslipType }"></bs-reward-tokens-selector-container>
        </div>
    } @else {
        <bs-digital-picks-toolbar [picks]="picks" [isTeaserBet]="true"></bs-digital-picks-toolbar>
    }
</div>
